import React, { useState } from 'react';
import styled from 'styled-components';
import backgroundDetailContact from '../assets/backgroundDetailContact.svg';
import backgroundDetailContactMobile from '../assets/backgroundDetailContactMobile.svg';
import iconProfileCIrcle from '../assets/iconProfileCIrcle.svg';
import iconEditContact from '../assets/iconEditContact.svg';
import calendarAddIcon from "../assets/calendarAddIcon.svg"
import ModalCalendario from "./ModalCalendario.jsx";
import iconCopy from "../assets/iconCopy.svg";
import { updateContactById } from "../../endpoints.js"
import { copyToClipboard } from "../../Utils/index.js"
import HistoricoComunicacion from "../../Components/Contacts/HistoricoComunicacion.jsx"
import iconAddSeguimiento from "./iconAddSeguimiento.svg"
import ModalAddSeguimiento from "./ModalAddSeguimiento.jsx"
import CardAuxSeguimiento from "./CardAuxSeguimiento.jsx"
import iconConvertClient from "./iconConvertClient.svg"
import ModalCreateClient from "./ModalCreateClient.jsx"
import { useWindowWidth } from "@react-hook/window-size";
import Swal from "sweetalert2";
import {convertirFecha} from "../../Utils/index.js"

const DetailContact =
  ({
    user,
    selectedContact,
    handlerOpenModal,
    openModal,
    handlerOpenModalSeguimiento,
    openModalAddSeguimiento,
    closeModal,
    setSeActualizoContacto,
    closeModalAddSeguimiento,
    getContacts,
    getContactID,
    setContacts,
    scrollContainerRef
  }) => {

    const onlyWidth = useWindowWidth();
    const [editarSeguimiento, setEditarSeguimiento] = useState(false);
    const [idSeguimientoAEditar, setIdSeguimiendoAEditar] = useState(null);
    const [openModalCreateClient, setOpenModalCreateClient] = useState(false)


    const handleFormClick = (e) => {
      e.stopPropagation(); // Evita que el evento de clic se propague hacia arriba
    };
    const handleFormClick1 = (e) => {
      e.stopPropagation(); // Evita que el evento de clic se propague hacia arriba
    };
    const handleFormClick2 = (e) => {
      e.stopPropagation(); // Evita que el evento de clic se propague hacia arriba
    };

    const closeModalCreateClient = () => {
      setOpenModalCreateClient(false)
    }

    const openModalCreateClientAux = () => {
      if (selectedContact.Seguimientos.length < 1) {
        Swal.fire({
          icon: "error",
          title: "Primero debe de crear un detalle de seguimiento.",
          confirmButtonText: "Listo",
          confirmButtonColor: "#003049",
        });
      } else {
        setOpenModalCreateClient(true)
      }
    }

    const copyPhone = (data) => copyToClipboard(data);

    return (
      <DivBoxContainer>
        {
          openModal ?
            <ModalCalendario
              contacto={selectedContact}
              onClose={closeModal}
              updateContactById={updateContactById}
              stopPropagation={handleFormClick}
              setSeActualizoContacto={setSeActualizoContacto}
              getContacts={getContacts}
              getContactID={getContactID}
              setContacts={setContacts}
              scrollContainerRef={scrollContainerRef}
            />
            : null
        }
        {
          openModalAddSeguimiento === true || editarSeguimiento === true ?
            <ModalAddSeguimiento
              contacto={selectedContact}
              onClose={closeModalAddSeguimiento}
              updateContactById={updateContactById}
              stopPropagation={handleFormClick1}
              setSeActualizoContacto={setSeActualizoContacto}
              getContacts={getContacts}
              getContactID={getContactID}
              setContacts={setContacts}
              scrollContainerRef={scrollContainerRef}
              user={user}
              idSeguimientoAEditar={idSeguimientoAEditar}
              setEditarSeguimiento={setEditarSeguimiento}
              setIdSeguimiendoAEditar={setIdSeguimiendoAEditar}
              editarSeguimiento={editarSeguimiento}
            />
            : null
        }
        {
          openModalCreateClient ?
            <ModalCreateClient
              contacto={selectedContact}
              onClose={closeModalCreateClient}

              stopPropagation={handleFormClick2}
              setSeActualizoContacto={setSeActualizoContacto}
              getContacts={getContacts}
              getContactID={getContactID}
              setContacts={setContacts}
              scrollContainerRef={scrollContainerRef}
              user={user}

            />
            : null
        }

        <DivContainer>

          <DivContentImage src={onlyWidth > 1100 ? backgroundDetailContact : backgroundDetailContactMobile} />

          <DivAsignadoText>Asignado: {selectedContact.User.name + " " + selectedContact.User.lastname}</DivAsignadoText>
          {
            user.type !== "Admin" || user.type !== "Supervisor" ?
              null :
              <ContainerBtnEditar src={iconEditContact} />
          }

          <DivColumnRelative>
            <ImageProfile src={selectedContact.image || iconProfileCIrcle} />
            <TextNameUser><b>{selectedContact.name} {selectedContact.lastname}</b></TextNameUser>

          </DivColumnRelative>

        </DivContainer>
        <DivColumn1>
          <DivRow1>

            <BotonCalendar
              style={{
                width: "auto",
                height: "auto",
                borderRadius: "8px",
              }}
              onClick={() => openModalCreateClientAux()}
            >
              <CalendarIconImg
                style={{
                  maxWidth: "20px",
                  maxHeight: "20px",
                }}
                src={iconConvertClient} />
              <b>Convertir en cliente</b>

            </BotonCalendar>
          </DivRow1>

        </DivColumn1>

        <DivColumn1 style={{
          margin: "16px 0px 0px 0px"
        }}>
          <DivRow1>
            <Text1 style={{
              fontSize: '16px',
              margin: '0px 0px 8px 0px'
            }}><b>Detalle de Seguimientos</b></Text1>
            <BotonCalendar
              onClick={() => handlerOpenModalSeguimiento()}
            >
              <CalendarIconImg src={iconAddSeguimiento} />
              <div style={{
                width: "auto",
                minWidth: "100%"
              }}>Agregar Seguimiento</div>

            </BotonCalendar>
          </DivRow1>

          <br />

          {
            selectedContact && selectedContact.Seguimientos.length > 0 ?
              selectedContact?.Seguimientos.map((data) => (
                <CardAuxSeguimiento
                  setIdSeguimiendoAEditar={setIdSeguimiendoAEditar}
                  setEditarSeguimiento={setEditarSeguimiento}
                  convertirFecha={convertirFecha}
                  key={data.id}
                  data={data} />
              )) :
              null
          }

        </DivColumn1>
        <DivColumn1 style={{
          margin: "16px 0px 0px 0px"
        }}>

          <DivRow1>
            <Text1 style={{
              fontSize: '16px',
              margin: '0px 0px 8px 0px'
            }}><b>Datos de contacto</b></Text1>
            <BotonCalendar
              onClick={() => handlerOpenModal()}
            >
              <CalendarIconImg src={calendarAddIcon} />
              <div style={{
                width: "auto",
                minWidth: "100%"
              }}>Agregar Observación</div>
            </BotonCalendar>
          </DivRow1>

          <Text1><b>Teléfono: </b>
            <a
              href={`https://api.whatsapp.com/send/?phone=${selectedContact.phone}&app_absent=0`}
              target='_blank'
            >
              {selectedContact.phone}
            </a>
            <dfn data-info="Copiar" class="tooltip-container" >
              <CopyBtn src={iconCopy} onClick={() => copyPhone(selectedContact.phone)} />
              <span class="tooltip-text">Copiar</span>
            </dfn>
          </Text1>

          <Text1><b>Teléfono2: </b>
            <a
              href={`https://api.whatsapp.com/send/?phone=${selectedContact.phone2}&app_absent=0`}
              target='_blank'
            >
              {selectedContact.phone2}
            </a>
            <dfn data-info="Copiar" class="tooltip-container" >
              <CopyBtn src={iconCopy} onClick={() => copyPhone(selectedContact.phone2)} />
              <span class="tooltip-text">Copiar</span>
            </dfn>
          </Text1>

          <Text1><b>Teléfono3: </b>
            <a
              href={`https://api.whatsapp.com/send/?phone=${selectedContact.phone3}&app_absent=0`}
              target='_blank' >
              {selectedContact.phone3}
            </a>
            <dfn data-info="Copiar" class="tooltip-container" >
              <CopyBtn src={iconCopy} onClick={() => copyPhone(selectedContact.phone3)} />
              <span class="tooltip-text">Copiar</span>
            </dfn>
          </Text1>

          <Text1><b>Email:</b> {selectedContact.email}</Text1>
          <Text1><b>Origen:</b> {selectedContact.origen}</Text1>
          <Text1><b>Via de contacto:</b> {selectedContact.viaDeContacto}</Text1>

          <HistoricoComunicacion
            observations={selectedContact.Observaciones}
            convertirFecha={convertirFecha}
          />
        </DivColumn1>
      </DivBoxContainer>
    );
  };

export default DetailContact;

const CalendarIconImg = styled.img`
  max-width:24px;
  max-height:28px;
  width:24px;
  height:28px;
  
`;
const CopyBtn = styled.img`
  max-width:16px;
  max-height:16px;
  width:16px;
  height:16px;
  margin: 0px 5px;
  cursor: pointer;
  &:hover{
    opacity:0.7;
  }
  &:active{
    zoom:0.9
  }
`;

const BotonCalendar = styled.div`
  border-color: #dadce0;
  box-shadow: rgba(0, 0, 0, .2) 0 1px 1px;
  cursor: pointer;
  margin: 0px 0px 0px 0px;
  align-self: end;
  gap: 8px;
  font-family: 'Montserrat',sans-serif;
  font-weight: 700;
  font-size: 12px;
  color: #07082c;
  padding: 4px 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 5px;
  height: auto;
  border-radius: 8px;
  width: auto;
  min-width: max-content;

  &:focus {
    outline: none;
  }

  &:hover {
    transition: all 0.1s linear;
    filter: opacity(0.5);
    box-shadow: rgba(0, 0, 0, .2) 0 1px 1px;
  }

  &:active {
    transform:scale(0.90)
  }
`;

const DivBoxContainer = styled.div`
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:center;
  width: -webkit-fill-available;
  height: auto;
`;

const ContainerBtnEditar = styled.img`
  position: relative;
  height: 25px;
  font-family: 'Montserrat',sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: #FFFFFF;
  background-color: #00000054;
  left: unset;
  padding: 5px;
  top: -175px;
  margin-right: 16px;
  margin-left: 93%;
  width: -webkit-fill-available;
  border-radius: 4px;
  filter: drop-shadow(0.2px 0.2px 0px #00000099);
  text-align: center;
`;

const DivAsignadoText = styled.div`
  position: relative;
  height: auto;
  font-family: 'Montserrat',sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: #FFFFFF;
  background-color: #00000099;
  left: unset;
  padding: 5px;
  margin-right: 16px;
  margin-left: 80%;
  width: -webkit-fill-available;
  top: -40px;
  border-radius: 4px;
  filter: drop-shadow(0.2px 0.2px 0px #c40000);
  text-align: center;
  @media only screen and (min-width:0px) and (max-width:1100px){
    top: -130px;
    margin: 0px 16px;
    font-size: 12px;
  }
`;

const TextNameUser = styled.span`
  width: auto;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 22px;
  color: #003049;
`;

const DivRow1 = styled.div`
  display:flex;
  flex-direction:row;
  align-items:flex-end;
  justify-content:flex-end;
  width: -webkit-fill-available;
  gap:5px;
`;

const DivColumn1 = styled.div`
  display:flex;
  flex-direction:column;
  align-items:flex-start;
  justify-content:center;
  width: -webkit-fill-available;
  margin: 65px 0% 0% 0%;
  padding: 16px 16px;
  border-radius:8px;
  gap:5px;
  background-color:#FFFFFF;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 50px;
`;

const DivColumnRelative = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  width: auto;
  z-index: 2;
  top: -80px;
  align-self: flex-start;
  margin-left: 16px;
  @media only screen and (min-width:1100px) and (max-width:1380px) {
  zoom:0.85
  }
  @media only screen and (min-width:0px) and (max-width:1100px) {
    margin-left: 0px;
    align-self: center;
    zoom:0.85
  }
`;

const DivContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: -webkit-fill-available;
  height: 180px;
  max-height: 180px;
  margin: 0px 0%
  gap:0px;
`;

const DivContentImage = styled.img`
  height: 150px;
  width: 100%;
  background-color: #FFFFFF;
  object-fit: cover;
  border-radius: 8px 8px 8px 8px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 50px;
`;

const ImageProfile = styled.img`
  height: 100px;
  width: 100px;
  background-color: #FFFFFF;
  object-fit: cover;
  border-radius: 100%;
  filter: drop-shadow(2px 4px 6px #cecece);
`;

const Text1 = styled.span`
  width: -webkit-fill-available;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 13px;
  color: #003049;
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  justify-content: flex-start;
  gap: 3px;
  height:18px;
`;